// extracted by mini-css-extract-plugin
module.exports = {"section":"ImgSection_section__XCDa8"};